import { render, staticRenderFns } from "./Popups.vue?vue&type=template&id=5911c5d7&"
import script from "./Popups.vue?vue&type=script&lang=js&"
export * from "./Popups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5911c5d7')) {
      api.createRecord('5911c5d7', component.options)
    } else {
      api.reload('5911c5d7', component.options)
    }
    module.hot.accept("./Popups.vue?vue&type=template&id=5911c5d7&", function () {
      api.rerender('5911c5d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/services/payments/Popups.vue"
export default component.exports